import React, { useEffect, useState, useContext } from "react";
import { Row, Col, Container } from "react-bootstrap";
import {
  DecryptAESdata,
  GetPostMethodData,
} from "../../../provider/ServiceProvider";
import renderHTML from "react-render-html";
import animation from "../../../images/jm-animation.gif";

import "./LoadStructure.css";

import URLstateContext from ".././../../provider/CommonContext";
import { trackEvent, trackPageView } from "../../utils/tracking";
function LoadStructure() {
  const [exitlod, setExitlod] = useState("");
  const { BaseURL } = useContext(URLstateContext);
  const [loadingshow, setloadingshow] = useState(false);

  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/SIDdisclosures/Load-Structure",
      "jmf_sid-disclosures_load-structure"
    );
    // trackPageView(
    //   "http://localhost:710/SIDdisclosures/Load-Structure",
    //   "jmf_sid-disclosures_load-structure"
    // );

    trackEvent({
      category: "Static Page",
      action: "SIDdisclosures Load Structure Page Loaded",
      label: "jmf_sid-disclosures_load-structure",
      value: 1,
    });
  }, []);

  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "Getfundexitload")
      .then((data) => {
        setloadingshow(false);
        if (data.data != null && data.data.length > 0) {
          setExitlod(DecryptAESdata(data.data));
        }
      })
      .catch((error) => {
        setloadingshow(false);
        console.log(error);
      });
  }, []);

  return (
    <>
      <section className="defin-unit product_fund-summary-sc" tabIndex="0" aria-label="Exit load structure information">
        <Container>
          <Row>
            <Col>
              {loadingshow ? (
                <div className="textcentervertex" role="status" aria-live="polite" aria-busy="true">
                  <img src={animation} alt="" aria-hidden="true"/>
                  <div className="model_popup">Please Wait...</div>
                </div>
              ) : (
                <div className="load-structure">
                  {exitlod.length === 0 ? (
                    <p className="errormsgComNew" role="alert">No Data Found !!!</p>
                  ) : (
                    exitlod.map(({ ExitLoad, FundName }) => (
                      <>
                        <p className="loadStructureFundName">{FundName}</p>
                        <p>{ExitLoad != null ? renderHTML(ExitLoad) : ""}</p>
                        <br />
                      </>
                    ))
                  )}
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default LoadStructure;
